import { render, staticRenderFns } from "./LiquidationDistributor.vue?vue&type=template&id=6596c9c7&"
import script from "./LiquidationDistributor.vue?vue&type=script&lang=js&"
export * from "./LiquidationDistributor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../home/ubuntu/albert_frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports